import React, { useEffect, useState } from 'react';
import { useErrorInputs } from '../../../../hooks/useErrorInputs';
import { useForm } from '../../../../hooks/useForm';
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";
import Switch from "@mui/material/Switch";
import Select from "@mui/material/Select";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { ExpandLess, ExpandMore, PostAdd } from '@mui/icons-material';

import { ManageOtherActions } from './ManageOtherActions';
import TableActionBasic from '../TableActionBasic';
import { ManageActions } from './ManageActions';

const initState = (id) => ({
    id: id,
    label: '',
    type: 'string',
    filterable: false,
    visible: id !== 'id'
});

export const MenuAndSubmenu = ({ data, handleSave, handleCloseModal, t }) => {
    const [columns, setColumns] = useState([]);
    const [col, setCol] = useState(initState('id'));
    const [visibleTable, setvisibleTable] = useState(false);
    const [errorInputs, , , validForm] = useErrorInputs({});
    //#region table
    const handleInputChange = ({ target }) => {
        setCol((prevValueInputs) => ({
            ...prevValueInputs,
            [target.name]: target.value
        }));
    }

    const handleAdd = () => {
        const requiredFields = ["id", "label"];
        if (!validForm(requiredFields, col))
            return false;
        setColumns(prevItems => [...prevItems, col]);
        setCol(initState(''));
    }

    const handleDelete = (id) => {
        setColumns(prevItems => prevItems.filter(item => item.id !== id));
        setCol(initState(''));
    }

    useEffect(() => {
        handleSave('table', columns);
    }, [columns, handleSave]);

    //#endregion

    //#region actions
    const [listActions, setListActions] = useState([]);
    const [valuesAction, handleInputChangeForm, handleDirectInputChangeForm, , reset] = useForm({
        accion: '',
        type: '',
        icon: '',
        color: ''
    });
    const [errorInputsB, , , validFormB] = useErrorInputs({});

    const validateFormB = () => {
        const requiredFields = ["accion", "icon", 'color', 'type'];
        return validFormB(requiredFields, valuesAction);
    };

    const handleDeleteAct = (index) => {
        setListActions(prevItems => prevItems.filter((_, i) => i !== index));
        reset();
    }

    const handleAddActoin = () => {
        if (validateFormB()) {
            setListActions(prevItems => [...prevItems, valuesAction]);
            reset();
        }
    }

    useEffect(() => {
        handleSave('button', listActions);
    }, [listActions, handleSave]);
    //#endregion

    useEffect(() => {
        if (data?.button)
            setListActions(data.button)
        if (data?.table)
            setColumns(data.table);
    }, [])


    return (
        <>
            <Box sx={{ mt: 2 }}>
                <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
                    <Grid size={{xs:10, sm:'auto'}}>
                        <Typography variant='h6' component='h6'>
                            {t("common.tableColumnsTitle")}
                        </Typography>
                    </Grid>
                    <Grid 
                        size={{xs:2, sm:'auto'}}         
                        sx={{
                            display: "flex",
                            justifyContent: { xs: "flex-start", sm: "flex-end" },
                            gap: 1
                        }}
                    >
                        <Tooltip title={t("add")}>
                            <IconButton onClick={handleAdd}>
                                <PostAdd /> 
                            </IconButton>
                        </Tooltip>
                        {columns.length > 0 && (
                            <Tooltip title={visibleTable ? t('hide') : t('show')}>
                                <IconButton
                                    onClick={() => setvisibleTable(!visibleTable)}
                                >
                                    {visibleTable ? <ExpandLess /> : <ExpandMore />}
                                </IconButton>
                            </Tooltip>
                        )}
                    </Grid>
                </Grid>

                <Grid container spacing={2}>
                    <Grid size={{xs:12, sm:6}}>
                        <TextField required fullWidth size='small' variant='outlined' name='id' label='Id columna'
                            error={errorInputs.id?.isError}
                            color={(errorInputs.id?.isError) && 'error'}
                            helperText={errorInputs.id?.messageError || ''}
                            disabled={!columns.length > 0}
                            value={col.id}
                            onChange={handleInputChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid size={{xs:12, sm:6}}>
                        <TextField required fullWidth size='small' variant='outlined' name='label' label='Nombre de la columna'
                            error={errorInputs.label?.isError}
                            color={(errorInputs.label?.isError) && 'error'}
                            helperText={errorInputs.label?.messageError || ''}
                            value={col.label}
                            onChange={handleInputChange}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid size={{xs:12, sm:6}}>
                        <FormControl fullWidth required size='small'>
                            <InputLabel id="type">{t('commonFields.type')}</InputLabel>
                            <Select label={t('commonFields.type')} name='type'
                                value={col.type}
                                onChange={handleInputChange}
                            >
                                {['string', 'number', 'boolean', 'date'].map((option, idx) => <MenuItem key={idx} value={option}>{option}</MenuItem>)}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={{xs:12, sm:3}}>
                        <FormControlLabel
                            labelPlacement="top"
                            control={
                                <Switch id='filterable' name='filterable'
                                    onChange={(e) => handleInputChange({target: { name: e.target.name, value: e.target.checked }})}
                                    checked={col.filterable}
                                    disabled={col.id == 'id'}
                                />
                            }
                            label={'Filterable'}
                        />
                    </Grid>
                    <Grid size={{xs:12, sm:3}}>
                        <FormControlLabel
                            labelPlacement="top"
                            control={
                                <Switch id='visible' name='visible'
                                    onChange={(e) => handleInputChange({target: { name: e.target.name, value: e.target.checked }})}
                                    checked={col.visible}
                                />
                            }
                            label={'Visible'}
                        />
                    </Grid>
                </Grid>
            </Box>

            {(columns.length && visibleTable) > 0 &&
                <TableActionBasic
                    columns={[
                        { label: 'Nombre', id: 'label' },
                        { label: 'Id', id: 'id' },
                        { label: 'Tipo', id: 'type' }
                    ]}
                    values={columns}
                    handleDelete={handleDelete}
                    t={t}
                />
            }

            <ManageActions
                values={valuesAction}
                errorInputs={errorInputsB}
                listActions={true}
                handleInputChange={handleInputChangeForm}
                handleDirectInputChange={handleDirectInputChangeForm}
                handleCloseModal={handleCloseModal}
                handleAdd={handleAddActoin}
                t={t}
            />

            <ManageOtherActions 
                data={data} 
                table={columns}
                handleSave={handleSave}
                t={t} 
            />

            {listActions.length > 0 &&
                <TableActionBasic
                    columns={[
                        { label: 'Nombre', id: 'accion' },
                        { label: 'Tipo', id: 'type' }
                    ]}
                    values={listActions}
                    handleDelete={(id, idx) => handleDeleteAct(idx)}
                    t={t}
                />
            }
        </>
    );
}
